export const modulesQuizQuestions = [
  {
    id: "modules-q1",
    question: "Module ko kaunsi analogy se samjha sakte hain?",
    options: ["Box", "Toolbox", "Bottle", "Variable"],
    correctIndex: 1,
    explanation: "Module ready-made toolbox ki tarah hota hai jisme useful code hota hai.",
  },
  {
    id: "modules-q2",
    question: "Kaunsa import syntax sahi hai?",
    options: ["module import random", "import random", "random from import", "import = random"],
    correctIndex: 1,
    explanation: "Python mein basic syntax `import random` hota hai.",
  },
  {
    id: "modules-q3",
    question: "Package ko kaise samjhen?",
    options: ["Aik function", "Aik comment", "Modules ka group", "Aik variable"],
    correctIndex: 2,
    explanation: "Package multiple related modules ka group hota hai.",
  },
];

export const moduleMistakes = [
  "Wrong module name likhna, jaise radnom ya dattime.",
  "Module aur package ko same samajhna.",
  "`from module import function` aur `import module` ka farq na samajhna.",
];

export const modulesFaqs = [
  {
    question: "Python module kya hota hai?",
    answer: "Module ready-made code file hoti hai jise import karke reuse kiya jata hai.",
  },
  {
    question: "Package aur module mein farq kya hai?",
    answer: "Module aik file hoti hai, jab ke package related modules ka group hota hai.",
  },
];
